import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS, type BffEndpoint } from '../../endpoints/BffEndpoints';
import type { HttpResponse } from '../../http/HttpClient';
import type { RouteListQueryParams, RoutesListResponse } from '../../models/bff/Route';
import { BffApiClient } from '../../clients/BffApiClient';
import { filterQueryParams } from '../../../utils/queryParams';

const NAME = 'routes';

/**
 * RouteRepository class for handling route-related API operations.
 * Uses the BFF API client by default but can be switched to other API clients.
 * Type-safe: Only allows BFF endpoints defined in BFF_ENDPOINTS.
 */
export class RouteRepository extends BaseRepository<BffEndpoint> {
  static override readonly name = NAME;

  constructor() {
    super(BffApiClient.getInstance());
  }

  /**
   * Retrieve all available routes filtered for a given criteria.
   *
   * @param queryParams - The route search criteria
   * @returns Promise<HttpResponse<RoutesListResponse>> - The available route list
   */
  list(queryParams?: RouteListQueryParams): Promise<HttpResponse<RoutesListResponse>> {

    const filteredParams = filterQueryParams(queryParams);

    return this.apiClient.get<RoutesListResponse>(
      BFF_ENDPOINTS.ROUTE_LIST,
      {
        query: filteredParams,
      },
    );
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: RouteRepository;
  }
}